import React, {Component} from "react";
import './RollingTip.scss';

export default class RollingTip extends Component {
    constructor(props) {
        super(props);
        this.msgList = [];
        this.msgIndex = 1;
        this.rollList = [];
        this.timeout = 5000;
        this.height = 20;
        this.running = true;

        this.position = {
            0: {
                translate: '0',
                duration: 1,
            },
            1: {
                translate: '-200%',
                duration: 1,
            },
        };
        this.state = {
            current: 0,
        };
    }

    componentWillMount() {
        this.initMsgList();
    }

    componentDidMount() {
        this.container?.addEventListener("transitionend", () => this.transitionend());
        this.interval = setInterval(() => this.rolling(), this.timeout);
        this.tipRef?.addEventListener("mouseenter", () => {this.running = false});
        this.tipRef?.addEventListener("mouseleave", () => {this.running = true});
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    initMsgList() {
        let {msgList} = this.props;
        this.msgList = msgList || [];
        this.rollList = this.msgList.slice(0, 2);
    }

    transitionend() {
        const current = this.state.current;
        this.msgIndex++;
        this.msgIndex = this.msgIndex >= this.msgList.length ? 0 : this.msgIndex;
        this.rollList[current] = this.msgList[this.msgIndex];

        if(current === 0) {
            this.position[0]['translate'] = '-100%';
            this.position[0]['duration'] = 0;
            this.setState({
                current: 1,
            });
        }
        else {
            this.position[1]['translate'] = '-200%';
            this.position[1]['duration'] = 0;
            this.setState({
                current: 0,
            });
        }
    }

    rolling() {
        if(!this.running){
            return;
        }

        let current = this.state.current;
        this.position[0]['translate'] = current === 0 ? '100%' : '0';
        this.position[0]['duration'] = 1;
        this.position[1]['translate'] = current === 0 ? '-100%' : '0';
        this.position[1]['duration'] = 1;

        this.setState({
            current,
        });
    }

    openUrl(url){
        window.open(url,"_blank")
    }

    render() {
        const containerStyle = {
            height: `${this.height}px`,
            '--item-height': `${this.height}px`,
        };

        return (<>
            <div className={"rolling-tip"} ref={(ref) => this.tipRef = ref}>
                <div className={"container"} style={containerStyle}>
                    {this.rollList.map((msg, index) => {
                        const position = this.position[index];
                        const itemStyle = {
                            transform: `translateY(${position['translate']})`,
                            transitionDuration: `${position['duration']}s`,
                        };
                        return <div className={"item"} style={itemStyle} key={index}
                                    onClick={() => this.openUrl(msg['activityUrl'])}
                                    ref={(ref) => {
                                        !this.container && (this.container = ref);
                                    }}>{msg['activityName']}</div>;
                    })}
                </div>
            </div>
        </>);
    }
}